import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Data from "../../dummy";
import Account from "./Account";
import { fetchDashboard } from "../../../states/actions/fetchDashboard";
import { useSelector, useDispatch } from "react-redux";
import LoadingScreen from "../../common/LoadingScreen";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import { ToastContainer } from "react-toastify";
import { websiteLink } from "../../../helpers/helpers";
import JobsEventsNew from "./Jobs-Event-New";
import Breadcrumb from "../../common/BreadCrumb";

const MyJobs = () => {
  const breadcrumbItems = [
    { name: "Dashboard", link: "/dashboard" },
    { name: "My Jobs", link: "/my-jobs" },
  ];
  const dispatch = useDispatch();
  const data = useSelector((state) => state.fetchDashboard.content);
  const memData = useSelector((state) => state.fetchSiteSettings.memData);
  const isLoading = useSelector((state) => state.fetchDashboard.isLoading);
  const isSiteSettingsLoading = useSelector(
    (state) => state.fetchSiteSettings.isLoading
  );
  const applied_jobs = useSelector(
    (state) => state.fetchDashboard.applied_jobs
  );
  const saved_jobs = useSelector((state) => state.fetchDashboard.saved_jobs);
  const job_offer_received = useSelector(
    (state) => state.fetchDashboard.job_offer_received
  );
  const job_interviewing = useSelector(
    (state) => state.fetchDashboard.job_interviewing
  );
  const job_rejections = useSelector(
    (state) => state.fetchDashboard.job_rejections
  );
  useEffect(() => {
    dispatch(fetchDashboard());
  }, []);
  const [jobsType, setJobsTyps] = useState(2);

  const handleToggleJobs = (param) => {
    setJobsTyps(param);
  };

  const { events, applied_job_actions, content } = data;
  useDocumentTitle("My Jobs - " + data.site_name);

  return (
    <>
      {isLoading || isSiteSettingsLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <ToastContainer />
          <section id="dash" className="n-dashboard">
            <Breadcrumb items={breadcrumbItems} />
            <div className="contain">
              {/* <div className="dash_new_txt text-center">
            <h3>👋 Welcome back, John!</h3>
            <p>Let's find your dream job today.</p>
          </div> */}

              <div className="outer_cmn_blk_dash">
                <div className="cmn_blk_new_dash">
                  <div className="top_head mb-3">
                    <h4 className="heading_dash">My Jobs</h4>
                    <div className="link_blk">
                      <Link to={websiteLink("/open-jobs/1")}>
                        View all jobs
                      </Link>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="col">
                      <Link
                        className={jobsType == 2 ? "inner active" : "inner"}
                        to="javascript:void(0)"
                        onClick={() => handleToggleJobs(2)}
                      >
                        <div className="left_content">
                          <p>Saved</p>
                          <h5>
                            {" "}
                            {saved_jobs && saved_jobs.length > 0
                              ? saved_jobs.length
                              : 0}
                          </h5>
                        </div>
                        <div className="right_content">
                          <div className="image_ico">
                            <img src="images/n-dashboard/job-1.svg" alt="" />
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className="col">
                      <Link
                        className={jobsType == 1 ? "inner active" : "inner"}
                        to="javascript:void(0)"
                        onClick={() => handleToggleJobs(1)}
                      >
                        <div className="left_content">
                          <p>Applied</p>
                          <h5>
                            {applied_jobs && applied_jobs.length > 0
                              ? applied_jobs.length
                              : 0}
                          </h5>
                        </div>
                        <div className="right_content">
                          <div className="image_ico">
                            <img src="images/n-dashboard/job-2.svg" alt="" />
                          </div>
                        </div>
                      </Link>
                    </div>

                    <div className="col">
                      <Link
                        className={jobsType == 3 ? "inner active" : "inner"}
                        to="javascript:void(0)"
                        onClick={() => handleToggleJobs(3)}
                      >
                        <div className="left_content">
                          <p>Interviewing</p>
                          <h5>
                            {job_interviewing && job_interviewing.length > 0
                              ? job_interviewing.length
                              : 0}
                          </h5>
                        </div>
                        <div className="right_content">
                          <div className="image_ico">
                            <img src="images/n-dashboard/job-3.svg" alt="" />
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className="col">
                      <Link
                        className={jobsType == 4 ? "inner active" : "inner"}
                        to="javascript:void(0)"
                        onClick={() => handleToggleJobs(4)}
                      >
                        <div className="left_content">
                          <p>Job Offers</p>
                          <h5>
                            {job_offer_received && job_offer_received.length > 0
                              ? job_offer_received.length
                              : 0}{" "}
                          </h5>
                        </div>
                        <div className="right_content">
                          <div className="image_ico">
                            <img src="images/n-dashboard/job-4.svg" alt="" />
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className="col">
                      <Link
                        className={jobsType == 5 ? "inner active" : "inner"}
                        to="javascript:void(0)"
                        onClick={() => handleToggleJobs(5)}
                      >
                        <div className="left_content">
                          <p>Rejections</p>
                          <h5>
                            {job_rejections && job_rejections.length > 0
                              ? job_rejections.length
                              : 0}
                          </h5>
                        </div>
                        <div className="right_content">
                          <div className="image_ico">
                            <img src="images/n-dashboard/job-5.svg" alt="" />
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                  {/* <JobsEventsNew
                    jobs={jobsType == 1 ? applied_jobs : saved_jobs}
                    applied_job_actions={applied_job_actions}
                    jobsType={jobsType}
                  /> */}
                  <JobsEventsNew
                    jobs={
                      jobsType === 1
                        ? applied_jobs
                        : jobsType === 2
                        ? saved_jobs
                        : jobsType === 3
                        ? job_interviewing
                        : jobsType === 4
                        ? job_offer_received
                        : jobsType === 5
                        ? job_rejections
                        : []
                    }
                    applied_job_actions={applied_job_actions}
                    jobsType={jobsType}
                    content={content}
                  />

                  {/* <div className="middle_content">
                    <div className="box_ico">
                      <img src="images/n-dashboard/job-6.svg" alt="" />
                    </div>
                    <div className="mobile_box_ico">
                      <img src="images/n-dashboard/job-7.svg" alt="" />
                    </div>
                    <div className="text_content">
                      <p>
                        <strong>No jobs applied yet</strong>
                      </p>
                      <p>
                        You haven't applied for any jobs. Start your job search
                        journey today!
                      </p>
                      <div className="cta">
                        <Link to="" className="site_btn">
                          Browse Open Positions
                        </Link>
                      </div>
                    </div>
                    
                  </div> */}
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default MyJobs;
